<template>
    <v-toolbar :flat="flat" dense class="ma-0" :class="customClass">
        <v-toolbar-title v-if="title" class="title-color">{{title}}</v-toolbar-title>
        <slot name="right_title_btn"></slot>
        <v-spacer v-if="title" />
        <slot name="initial_btns"></slot>
        <div v-for="btn_action in actions['icon_btn']" :key="btn_action['id']">
            <v-tooltip top v-if="btn_action.hasOwnProperty('name') && btn_action.hasOwnProperty('icon') && show_actions">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        icon
                        :disabled="disableActions"
                        @click="selectedAction(btn_action['id'])"
                    >
                        <AppIcon v-if="btn_action['icon'].includes('.svg')" :src="btn_action['icon']" :size="32" :colorMap="{ '663399': 'primary', '66359B': 'primary' }" />
                        <v-icon v-else color="primary">{{ btn_action['icon'] }}</v-icon>
                    </v-btn>
                </template>
                <span>{{ btn_action['name'] }}</span>
            </v-tooltip>
            <!-- <v-btn v-else-if="show_actions && btn_action.hasOwnProperty('icon')" color="primary" @click="selectedAction(btn_action['id'])" icon>
                <v-icon color="primary">
                    {{ btn_action['icon'] }}
                </v-icon>
            </v-btn> -->
        </div>
        <slot name="mid_btns"></slot>
        <action-selector
            v-if="show_actions"
            store="documents"
            :actions="actions"
            :groups="groups"
            :loading="loading"
            :disabled="disabled"
            @job-done="$emit('job-done')"
            @selected-action="selectedAction"
            class="mr-2"
            :show_actions_selector="show_actions_selector"
        ></action-selector>
        <div v-for="btn_action in actions['btn']" :key="btn_action['id']">
            <v-btn v-if="show_actions" color="primary" @click="selectedAction(btn_action['id'])" :disabled="disableActions" class="mr-2">
                {{ btn_action['name'] }}
            </v-btn>
        </div>
        <slot name="end_btns"></slot>
    </v-toolbar>
</template>

<script>
import ActionSelector from './ActionSelector.vue';

export default {
    name: 'TableListToolbar',
    components: {
        ActionSelector
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        actions: {
            type: Object,
            required: true,
            default: function () {
                return {};
            }
        },
        groups: {
            type: Object,
            default: function () {
                return {};
            }
        },
        loading: {
            type: Boolean,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true,
            default: false
        },
        show_actions: {
            type: Boolean,
            required: true,
            default: true
        },
        job_state: {
            type: String,
            required: false,
            default: '',
        },
        flat: {
            type: Boolean,
            default: false,
        },
        customClass: {
            type: String,
            required: false,
            default: '',
        },
    },
    computed: {
        disableActions() {
            let dis = false;
            if (this.disabled) {
                dis = this.disabled;
            } else if (this.loading) {
                dis = this.loading;
            } else if (this.job_state == 'running') {
                dis = true;
            }
            return dis;
        },
        show_actions_selector(){  
            return this.actions.hasOwnProperty('action') || this.actions.hasOwnProperty('download') || 
            this.actions.hasOwnProperty('massive') || this.actions.hasOwnProperty('state');         
        }
    },
    methods:{
        selectedAction(action_id) {
            this.$emit('selected-action', action_id)
        }
    }
}
</script>

<style scoped>
.rounded-top {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
</style>
